window.addEventListener('DOMContentLoaded', () => {
    const swiperContainers = document.querySelectorAll('.js-statement-swiper-container');

    if (!swiperContainers.length) {
        return;
    }

    swiperContainers.forEach((swiperContainer) => {
        const items = swiperContainer.querySelectorAll('.js-statement-swiper-items > *');
        items.forEach((item) => item.classList.add('swiper-slide'));

        const autoplayDelay = Number(swiperContainer.dataset.autoplayDelay);
        let autoplay;
        if (autoplayDelay) {
            autoplay = {
                autoplay: {
                    delay: autoplayDelay,
                    pauseOnMouseEnter: true,
                },
            };
        } else {
            autoplay = {};
        }

        new Swiper(swiperContainer, {
            slidesPerView: 'auto',
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            ...autoplay,
        });
    });
});
